/**
 * The canvas's named icons, as handed over by the server at mount.
 *
 * PHP (CanvasIcons) is the only source of the SVG paths: the board page serialises the
 * registry onto the island element and mount.js deposits it here before anything renders. A
 * second copy in JS would be a list that drifts — the exact bug the appearance system was
 * built to avoid.
 *
 * The markup is trusted by construction: it comes from a PHP class constant in this repo,
 * never from user input. User-typed icons are emoji and render as text, not through here.
 */
let ICONS = {};

/** Install the registry (name → inner SVG markup). Called once per mount. */
export function setIcons(map) {
    ICONS = map && typeof map === 'object' ? map : {};
}

/** The inner SVG for a named icon, or null when the icon is an emoji / unknown. */
export function iconInner(name) {
    return typeof name === 'string' ? (ICONS[name] ?? null) : null;
}
